import { Stack, Typography } from "@mui/material";
import { getBaseUrl } from "../LandingOne";

const NotificationComponent = () => {
  const newLink = getBaseUrl();

  return (
    <div
      style={{
        width: "100%",
        height: "fit-content",
        backgroundColor: "#77EBFF",
        position: "fixed",
        zIndex: 100
      }}
    >
      <Stack
        direction={"row"}
        sx={{
          padding: { xs: "6px", sm: "12px" },
          justifyContent: "center",
          alignItems: "center"
        }}
        spacing={"8px"}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 4C7.58182 4 4 7.58182 4 12C4 16.4182 7.58182 20 12 20C16.4182 20 20 16.4182 20 12C20 7.58182 16.4182 4 12 4ZM11.6364 7.63636C11.4435 7.63636 11.2585 7.71299 11.1221 7.84938C10.9857 7.98577 10.9091 8.17075 10.9091 8.36364C10.9091 8.55652 10.9857 8.74151 11.1221 8.8779C11.2585 9.01429 11.4435 9.09091 11.6364 9.09091H12C12.1929 9.09091 12.3779 9.01429 12.5143 8.8779C12.6507 8.74151 12.7273 8.55652 12.7273 8.36364C12.7273 8.17075 12.6507 7.98577 12.5143 7.84938C12.3779 7.71299 12.1929 7.63636 12 7.63636H11.6364ZM10.5455 10.5455C10.3526 10.5455 10.1676 10.6221 10.0312 10.7585C9.89481 10.8949 9.81818 11.0798 9.81818 11.2727C9.81818 11.4656 9.89481 11.6506 10.0312 11.787C10.1676 11.9234 10.3526 12 10.5455 12H11.2727V14.1818H10.5455C10.3526 14.1818 10.1676 14.2584 10.0312 14.3948C9.89481 14.5312 9.81818 14.7162 9.81818 14.9091C9.81818 15.102 9.89481 15.287 10.0312 15.4234C10.1676 15.5597 10.3526 15.6364 10.5455 15.6364H13.4545C13.6474 15.6364 13.8324 15.5597 13.9688 15.4234C14.1052 15.287 14.1818 15.102 14.1818 14.9091C14.1818 14.7162 14.1052 14.5312 13.9688 14.3948C13.8324 14.2584 13.6474 14.1818 13.4545 14.1818H12.7273V11.2727C12.7273 11.0798 12.6507 10.8949 12.5143 10.7585C12.3779 10.6221 12.1929 10.5455 12 10.5455H10.5455Z"
            fill="#00286D"
          />
        </svg>
        <Typography
          sx={{
            color: "var(--Mjr-blue-2, #00286D)",
            fontFamily: "Switzer",
            fontSize: { xs: "10px", sm: "16px" },
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "normal",
            textAlign: "center"
          }}
        >
          It's moved! Head over to&nbsp;
          <a
            style={{
              textDecoration: "underline"
            }}
            href={newLink}
          >
            {newLink.replace("https://", "")}
          </a>
          &nbsp;to log in
        </Typography>
      </Stack>
    </div>
  );
};

export default NotificationComponent;
